import About1 from "../Components/About/About1";
import Blog1 from "../Components/Blog/Blog1";
import Brand1 from "../Components/Brand/Brand1";
import Choose1 from "../Components/Choose/Choose1";
import Counter1 from "../Components/Counter/Counter1";
import Cta1 from "../Components/Cta/Cta1";
import Faq1 from "../Components/Faq/Faq1";
import Feature1 from "../Components/Feature/Feature1";
import Feature2 from "../Components/Feature/Feature2";
import HeroBanner1 from "../Components/HeroBanner/HeroBanner1";
import HowWork from "../Components/HowWork/HowWork";
import Pricing1 from "../Components/Pricing/Pricing1";
import Testimonial from "../Components/Testimonial/Testimonial";

const Home = () => {
    return (
        <div>
            <HeroBanner1
                subtitle="<span>Pronto para Crescer?</span>#fhctraffic"
                title="Transforme visitantes em clientes. Escale com inteligência."
                content="Com a FHC Traffic & Mídia, você vai além do básico. Nossa expertise em tráfego pago foi desenvolvida para empresas que querem crescer com agilidade, otimizar investimentos e ter resultados mensuráveis."
                FeatureList={[
                    "ROI comprovado em campanhas de tráfego pago",
                    "Estratégias personalizadas para seu negócio",
                    
                ]}   
                btnname="Solicitar Orçamento"
                btnurl="https://wa.me/5511999887766?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20FHC%20Traffic!"
                btntwo="Fale com um Especialista"
                btn2url="mailto:contato@fhctraffic.com.br"
                cusimg="/assets/images/intro/introProfileThumb1_1.png"
                cusnumber="150+"
                cuscontent="Clientes Atendidos"
                rating="4.9/5"
                ratingcon="Estrelas"
                img="/assets/images/intro/home.png"
            ></HeroBanner1>
            
            <About1
                img1="/assets/images/about/aboutThumb1_1.png"
                img2="/assets/images/about/aboutThumb1_2.png"
                subtitle="Sobre a FHC Traffic"
                title="A agência que entende o seu negócio."
                content="A maioria das agências trabalha com fórmulas prontas. Com a FHC Traffic & Mídia, você tem estratégias personalizadas, análise profunda do seu mercado e otimização contínua. Do primeiro clique à conversão, tudo é pensado para maximizar seus resultados."
                FeatureList={[
                    "Campanhas otimizadas para conversão",
                    "Análise detalhada do público-alvo",
                    "Relatórios transparentes e em tempo real",
                    "Integração com ferramentas de vendas",
                    "Suporte especializado e consultoria estratégica",
                    
                ]}                
                btnname="Quero Conhecer os Serviços"
                btnurl="https://wa.me/5511999887766?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20FHC%20Traffic!"
            ></About1>
            <HowWork></HowWork>
            <Choose1
                subtitle="Nossas Vantagens"
                title="Muito mais que tráfego pago. A solução completa para seu crescimento digital."
                content="Com a FHC Traffic & Mídia, você vai além do básico. Nossa expertise foi desenvolvida para empresas que querem crescer com inteligência, otimizar investimentos e dominar o mercado digital de ponta a ponta."
                // FeatureList={[
                //     "ROI Otimizado",
                //     "Dados em Tempo Real",
                // ]} 
                // FeatureList2={[
                //     "Estratégias Personalizadas",
                //     "Campanhas otimizadas para conversão",
                // ]}                 
                btnname="Descubra como funciona"
                btnurl="https://wa.me/5511999887766?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20FHC%20Traffic!"
            ></Choose1>
            <Feature1></Feature1>
            <Counter1></Counter1>
            <Faq1></Faq1>
            
            <Testimonial></Testimonial>
            <Feature2></Feature2>
            <Pricing1></Pricing1>
            <Cta1
                
                title="Comece Agora e Transforme Seus Resultados Digitais!"
                content="Com a FHC Traffic & Mídia, você tem acesso a estratégias comprovadas, relatórios detalhados e suporte especializado — tudo para maximizar seu ROI. Entre em contato e comece a escalar seu negócio com inteligência e resultados mensuráveis."
                btnurl1="https://wa.me/5511999887766?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20FHC%20Traffic!"
                btnurl2="mailto:contato@fhctraffic.com.br"
                img="/assets/images/cta/ctaThumb1_1.png"
            ></Cta1>
            {/* <Blog1></Blog1> */}
        </div>
    );
};

export default Home;